export var FieldMappingsTabs;
(function (FieldMappingsTabs) {
    FieldMappingsTabs["Base"] = "dashboard.tools.field-mapping";
    FieldMappingsTabs["Mappings"] = "dashboard.tools.field-mapping.mapping-configuration";
    FieldMappingsTabs["Errors"] = "dashboard.tools.field-mapping.mapping-errors";
})(FieldMappingsTabs || (FieldMappingsTabs = {}));
export var FieldMappingSubjects;
(function (FieldMappingSubjects) {
    FieldMappingSubjects["Page"] = "field-mappings";
    FieldMappingSubjects["EmptyState"] = "field-mapping-empty-state";
    FieldMappingSubjects["ApplyNotification"] = "apply-mapping";
    FieldMappingSubjects["ConfirmModal"] = "confirm-modal";
    FieldMappingSubjects["ResolveError"] = "resolve-error";
})(FieldMappingSubjects || (FieldMappingSubjects = {}));
//# sourceMappingURL=field-mappings.enum.js.map